export default {
  getHeaders(vm) {
    return [
      {
        key: 'nomeRede',
        label: vm.$t('network-management.fields.name'),
      },
      {
        key: 'ip',
        label: vm.$t('network-management.fields.ip'),
      },
      {
        key: 'porta',
        label: vm.$t('network-management.fields.port'),
      },
      {
        key: 'status',
        label: vm.$t('network-management.fields.status'),
      },
      {
        key: 'modoModBus',
        label: vm.$t('network-management.fields.mode-connect'),
        sortable: false,
      },
      {
        key: 'protocolo',
        label: vm.$t('network-management.fields.driver-protocol'),
        sortable: false,
      },
      {
        key: 'view-network',
        label: '',
        class: 'max-view-network-width',
      },
      {
        key: 'edit-network',
        label: '',
        class: 'buttons-installation-network',
      },
      {
        key: 'delete-network',
        label: '',
        class: 'buttons-installation-network',
      },
      {
        key: 'actions',
        label: '',
        class: 'max-actions-width',
      },
    ];
  },
};
